"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var commonFunctions_1 = require("../../../../commonFunctions");
var AnnualHomeSpecifiedItemInfo = /** @class */ (function (_super) {
    __extends(AnnualHomeSpecifiedItemInfo, _super);
    function AnnualHomeSpecifiedItemInfo(props) {
        return _super.call(this, props) || this;
    }
    AnnualHomeSpecifiedItemInfo.prototype.render = function () {
        var _this = this;
        var items = this.props.items;
        var filteredItems = items ? items.filter(function (item) { return item.flowValuable; }) : [];
        if (filteredItems && filteredItems.length > 0) {
            var addedItems = filteredItems.map(function (item) {
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "mt-2 mb-3 margin-top-28 margin-bottom-2", children: _this.renderItemPanel(item) }), (0, jsx_runtime_1.jsx)("div", { className: "border-bottom-dashed-blue mt-2 mb-3" })] }));
            });
            return ((0, jsx_runtime_1.jsxs)("div", { className: "mt-3 mb-0", children: __spreadArray([], addedItems, true) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    AnnualHomeSpecifiedItemInfo.prototype.renderItemPanel = function (item) {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("b", { children: item.description }), " (", (0, commonFunctions_1.getAmountToDisplay)(item.value), ")"] }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex justify-content-between justify-content-md-start mt-2 font-weight-bold text-blue-1", children: [(0, jsx_runtime_1.jsx)("span", { onClick: function () { return _this.props.editItem(item); }, className: "mr-5 cursor-pointer blue-link-underline", children: "Edit" }), (0, jsx_runtime_1.jsxs)("span", { onClick: function () { return _this.props.removeItem(item); }, className: "cursor-pointer ml-auto", children: ["-", ' ', (0, jsx_runtime_1.jsx)("span", { onClick: function () { return _this.props.removeItem(item); }, className: "cursor-pointer blue-link-underline", children: "Remove" })] })] })] }));
    };
    ;
    return AnnualHomeSpecifiedItemInfo;
}(React.Component));
exports.default = AnnualHomeSpecifiedItemInfo;
//# sourceMappingURL=AnnualHomeSpecifiedItemInfo.js.map